import type { SupportedLanguage } from "@amtana/i18n";
import { createContext, useContext } from "react";

/** The open screen's own `languages` (ADR-029 point 2); undefined means every shipped language. */
export const ScreenLanguagesContext = createContext<readonly SupportedLanguage[] | undefined>(undefined);

/** The languages the open screen exists in, or undefined when it exists in every shipped one. */
export function useScreenLanguages(): readonly SupportedLanguage[] | undefined {
  return useContext(ScreenLanguagesContext);
}
